export default __webpack_public_path__ + "static/media/html.bf6bb1c2.svg";